<app-shared-dialog [title]="'inventory.product_edit_pricing.title' | translate" 
  [options]="{
    size: 'large',
    titleIcon: 'pen-cc',
    titleIconColor: 'primary',
    confirmText: 'inventory.product_edit_pricing.save' | translate,
    cancelText: 'inventory.product_edit_pricing.cancel' | translate,
    confirmButtonStyle: 'primary',
    customConfirmButton: true
  }" (cancel)="cancel()">

  <div class="pricing-container" [formGroup]="form">
    <!-- Default Currency Block -->
    <div class="currency-block">
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.currency' | translate }}</label>
        <div class="currency-select-wrapper">
          <mat-select formControlName="default_currency" [disabled]="true">
            <mat-select-trigger *ngIf="form.get('default_currency')?.value">
                <span class="tag">{{default_currency?.name}} ({{default_currency?.symbol}})</span>
            </mat-select-trigger>
            <mat-option [value]="default_currency">
              {{ default_currency?.name }} ({{ default_currency?.symbol }})
            </mat-option>
          </mat-select>
        </div>
        <div class="delete-wrapper"></div>
      </div>

      <div class="variants-container">
        <table class="variants-table">
            <thead>
              <tr class="row header">
                <th>{{"inventory.product_edit_basic_infos.variant" | translate}}</th>
                <th>{{ 'inventory.product_edit_pricing.retail_price' | translate }}</th>
                <th>{{ 'inventory.product_edit_pricing.product_cost' | translate }}</th>
              </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let variant of variants; let i = index">
                  <tr class="row body" [formGroup]="variantsFormArray[i]">
                    <td>
                        <div class="variant-name">
                            <div class="tags-container">
                                <span class="tag" *ngFor="let value of variant.values">
                                    {{value}}
                                </span>
                            </div>
                        </div>
                    </td>   
                    <td>
                      <div class="standard-input">
                        <input type="number" step="0.01" placeholder="0.00"
                            min="0" formControlName="sales_price" 
                            (keydown)="preventNegativeInput($event)" />
                        <span class="symbol">{{ default_currency?.symbol }}</span>
                      </div>
                    </td> 
                    <td>
                      <div class="standard-input">
                        <input type="number" step="0.01" placeholder="0.00"
                            min="0" formControlName="cost" 
                            (keydown)="preventNegativeInput($event)" />
                        <span class="symbol">{{ default_currency?.symbol }}</span>
                      </div>
                    </td>          
                  </tr>
                </ng-container>
            </tbody>
          </table>
      </div>
    </div>

    <!-- Additional Currency Blocks -->
    <div class="currency-block" *ngFor="let addedCurrency of addedCurrencies; let currencyIndex = index">
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.currency' | translate }}</label>
        <div class="currency-select-wrapper">
          <mat-select [formControl]="addedCurrency.controls.currency">
            <mat-select-trigger *ngIf="addedCurrency.controls.currency.value">
                <span class="tag">{{ addedCurrency.data.name }} ({{ addedCurrency.data.symbol }})</span>
            </mat-select-trigger>
            <mat-option *ngFor="let opt of getAvailableCurrenciesForSelect(currencyIndex)" [value]="opt.id">
              {{ opt.name }} ({{ opt.symbol }})
            </mat-option>
          </mat-select>
        </div>
        <div class="delete-wrapper">
          <button class="delete-btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="removeCurrency(currencyIndex)">
            <img src="assets/icones/delete_btn.svg" alt="delete" class="delete-icon" />
          </button>
        </div>
      </div>

      <div class="variants-container">
        <table class="variants-table">
            <thead>
              <tr class="row header">
                <th>{{"inventory.product_edit_basic_infos.variant" | translate}}</th>
                <th>{{ 'inventory.product_edit_pricing.retail_price' | translate }}</th>
                <th>{{ 'inventory.product_edit_pricing.product_cost' | translate }}</th>
              </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let variant of variants; let variantIndex = index">
                  <tr class="row body" [formGroup]="addedCurrency.controls.variants[variantIndex]">
                    <td>
                        <div class="variant-name">
                            <div class="tags-container">
                                <span class="tag" *ngFor="let value of variant.values">
                                    {{value}}
                                </span>
                            </div>
                        </div>
                    </td>   
                    <td>
                      <div class="standard-input" formGroupName="retail_price">
                        <input type="number" step="0.01" placeholder="0.00"
                            min="0" formControlName="amount" 
                            (keydown)="preventNegativeInput($event)" />
                        <span class="symbol">{{ addedCurrency.data.symbol }}</span>
                      </div>
                    </td> 
                    <td>
                      <div class="standard-input" formGroupName="cost">
                        <input type="number" step="0.01" placeholder="0.00"
                            min="0" formControlName="amount" 
                            (keydown)="preventNegativeInput($event)" />
                        <span class="symbol">{{ addedCurrency.data.symbol }}</span>
                      </div>
                    </td>          
                  </tr>
                </ng-container>
            </tbody>
          </table>
      </div>
    </div>

    <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
      <div class="add-currency" *ngIf="availableCurrencies.length > 0" (click)="addCurrency(undefined)">
        <mat-icon>add</mat-icon>
        <span>{{ 'inventory.product_edit_pricing.add_currency' | translate }}</span>
      </div>
    </ng-container>
  </div>
  <ui-button
    customConfirm
    *appHasPermission="{ module: 'product', action: 'edit' }"
    type="primary"
    [label]="'inventory.product_edit_pricing.save' | translate"
    (click)="save()">
  </ui-button>
</app-shared-dialog>